import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/auth';
import '../LoginPage/LoginPage.css';
// White-text variant — the branding panel is dark navy, so the dark logo is invisible on it.
import logoLight from '../../assets/landing/icons/logo-footer.svg';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [resendLoading, setResendLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await authService.verifyEmailOTP(email, otp);
      setSuccess('Email verified successfully! Redirecting to login...');
      setTimeout(() => {
        navigate('/login', { state: { message: 'Email verified successfully! Please login.' } });
      }, 2000);
    } catch (err) {
      setError(err.message || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setError('');
    setSuccess('');

    try {
      await authService.resendVerification(email, 'otp');
      setSuccess('Verification code sent! Please check your email.');
    } catch (err) {
      setError(err.message || 'Failed to resend code.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="auth-page login-page">
      <div className="top-accent-bar"></div>

      <div className="auth-container">
        <div className="auth-branding">
          <Link to="/" className="auth-logo">
            <img src={logoLight} alt="Marquee Couriers" />
          </Link>
          <div className="auth-branding-content">
            <h1>Verify Your Email</h1>
            <p>
              We've sent a verification code to <strong>{email}</strong>.
              Please enter it below to verify your account.
            </p>
          </div>
        </div>

        <div className="auth-form-section">
          <div className="auth-form-container">
            <div className="auth-form-header">
              <h2>Enter Verification Code</h2>
              <p>Check your email for the 6-digit code</p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit}>
              {error && (
                <div className="error-message" style={{
                  padding: '12px',
                  marginBottom: '20px',
                  backgroundColor: '#fee',
                  border: '1px solid #fcc',
                  borderRadius: '4px',
                  color: '#c33',
                  fontSize: '14px'
                }}>
                  {error}
                </div>
              )}

              {success && (
                <div className="success-message" style={{
                  padding: '12px',
                  marginBottom: '20px',
                  backgroundColor: '#d1fae5',
                  border: '1px solid #6ee7b7',
                  borderRadius: '4px',
                  color: '#059669',
                  fontSize: '14px'
                }}>
                  {success}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="otp">Verification Code</label>
                <input
                  type="text"
                  id="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit code"
                  required
                  maxLength={6}
                  disabled={loading}
                  style={{ textAlign: 'center', letterSpacing: '0.5em', fontSize: '1.2rem' }}
                />
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Verifying...' : 'Verify Email'}
              </button>

              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <p style={{ fontSize: '14px', color: '#666' }}>
                  Didn't receive the code?{' '}
                  <button
                    type="button"
                    onClick={handleResend}
                    disabled={resendLoading}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#C9A32C',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    {resendLoading ? 'Sending...' : 'Resend Code'}
                  </button>
                </p>
              </div>
            </form>

            <p className="auth-switch">
              Already verified? <Link to="/login">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
